import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, watch, inject, ref } from 'vue';
import { IKAgentsSelected } from '@/views/agents/components/agents-table/agents-table.InjectionKeys';
import { AgentsQuery, useSelectedAgentsLazyQuery } from '@/graphql/codegen/generated/graphql';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { NetworkStatus } from '@apollo/client/core';
import AgentActionMenu from './AgentActionMenu.vue';
import AgentBulkActionMenu from './AgentBulkActionMenu.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DynamicAgentActionMenu',
  props: {
    beforeHide: null,
    agentsQueryResult: null,
    contextMenu: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  beforeHide: () => void;
  agentsQueryResult: AgentsQuery['agents'];
  contextMenu: boolean;
}

const selectedAgents = inject(IKAgentsSelected);
const selectedAgentsList = useSelectedAgentsLazyQuery();
const coordinatorService = inject(IKCoordinatorsService);



const agentBulkMenuVisible = ref(false);

selectedAgentsList.onResult(resultSelectedAgents => {
  if (resultSelectedAgents.networkStatus === NetworkStatus.ready) {
    agentBulkMenuVisible.value = (resultSelectedAgents.data?.agents?.agents?.length || 0) > 1;
    selectedAgents?.selectByIds(new Set([...(resultSelectedAgents.data?.agents?.agents?.map(agent => agent?.id || '') || [])]));
  }
});

const openAgentActionsMenu = async () => {
  const payload = {
    filter: {
      coordinatorId: coordinatorService?.selectedCoordinator.value,
      agentsIdFilter: Array.from(selectedAgents?.selectedAgentIds.value || []),
    },
  };
  if (selectedAgentsList.networkStatus.value) {
    selectedAgentsList.refetch(payload);
  } else {
    selectedAgentsList.load(undefined, payload, { fetchPolicy: 'no-cache' });
  }
};

watch(
  () => props.contextMenu,
  newVal => {
    if (newVal) {
      openAgentActionsMenu();
    }
  },
);
const singleAgent = computed(() =>
  selectedAgents?.selectedAgentIds?.value?.size === 1 ? props.agentsQueryResult?.agents?.find(agent => selectedAgents?.selectedAgentIds?.value.has(agent?.id || '')) : null,
);

return (_ctx: any,_cache: any) => {
  return (_unref(singleAgent) && __props.contextMenu)
    ? (_openBlock(), _createBlock(AgentActionMenu, {
        key: 0,
        offset: [0, 8],
        agent: _unref(singleAgent),
        "agent-name": _unref(singleAgent).name,
        "before-hide": __props.beforeHide,
        "context-menu": __props.contextMenu
      }, null, 8, ["agent", "agent-name", "before-hide", "context-menu"]))
    : (__props.contextMenu)
      ? (_openBlock(), _createBlock(AgentBulkActionMenu, {
          key: 1,
          modelValue: agentBulkMenuVisible.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((agentBulkMenuVisible).value = $event)),
          agents: _unref(selectedAgentsList).result.value?.agents?.agents as any || [],
          "before-hide": __props.beforeHide
        }, null, 8, ["modelValue", "agents", "before-hide"]))
      : _createCommentVNode("", true)
}
}

})